module.exports = __webpack_public_path__ + "img/twitter.6dcf43d.png";